export default __webpack_public_path__ + "static/media/growth.d1a66b4c.svg";